export default __webpack_public_path__ + "static/media/book-intro.453ea3c1.png";